import styled from "@emotion/styled";

/**
 * Gives a plain MUI Paper the brand surface: white, 1px light-grey border,
 * square corners, no shadow. The theme covers most widgets; this exists for
 * the screens that still use `<Paper>` directly.
 */
const PaperWrapper = styled("div")(() => ({
  "& > .MuiPaper-root": {
    background: "#ffffff",
    border: "1px solid var(--tpc-200, #dcdcdc)",
    borderRadius: 0,
    boxShadow: "none",
  },
}));

export default PaperWrapper;
